"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = exports.createEmptyEmail = exports.isEmailEmpty = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var formik_1 = require("formik");
var react_i18next_1 = require("react-i18next");
var SelectField_1 = __importDefault(require("../SelectField"));
var TextField_1 = __importDefault(require("../TextField"));
var AutoCompleteField_1 = __importDefault(require("../AutoCompleteField"));
var isEmailEmpty = function (email) { return email.value === ''; };
exports.isEmailEmpty = isEmailEmpty;
var createEmptyEmail = function (type, primary) {
    if (primary === void 0) { primary = true; }
    return ({
        value: '',
        primary: primary,
        type: type,
    });
};
exports.createEmptyEmail = createEmptyEmail;
var getValue = function (part, oldValue, newValue) {
    var common = {
        primary: false,
        value: '',
    };
    if (part === 'name') {
        return __assign(__assign({}, common), { value: "".concat(newValue, "@").concat(oldValue.split('@')[1] || '') });
    }
    return __assign(__assign({}, common), { value: "".concat(oldValue.split('@')[0] || '', "@").concat(newValue) });
};
exports.getValue = getValue;
var contains = function (domains) {
    return !!(domains && domains.length);
};
function EmailField(props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var readOnly = props.readOnly, name = props.name, domains = props.domains, label = props.label, required = props.required, freeDomains = props.freeDomains, defaultUserName = props.defaultUserName;
    var _a = __read((0, formik_1.useField)(name), 3), fieldProps = _a[0], meta = _a[1], helpers = _a[2];
    var value = meta.value, error = meta.error;
    var email = value.value;
    var setValue = helpers.setValue, setTouched = helpers.setTouched;
    // const { firstPartError, setFirstPartFocused, domainError, setDomainFocused } =
    //   useValidate(email, meta.touched);
    return (contains(domains) || freeDomains) && !readOnly ? ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
            display: 'grid',
            gridTemplateColumns: '1fr fit-content(1px) 1fr',
            gridGap: '1rem',
        } }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(name, ".email"), label: t('ds.users.email first part'), value: (email || defaultUserName || '').replace(/@[^@]*$/, ''), disableFormik: true, forceError: (email || defaultUserName || '').replace(/@[^@]*$/, '').length === 0
                    ? 'required'
                    : undefined, required: required, onChange: function (e) {
                    setTouched(true);
                    setValue(__assign(__assign({}, fieldProps.value), { value: "".concat(e.target.value
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .replace(/\.+/g, '.')
                            .replace(/[^a-z0-9.-]/g, ''), "@").concat((email || defaultUserName || '').split('@')[1] || '') }));
                } }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { alignSelf: 'center', pt: '20px' } }, { children: "@" })), freeDomains && domains && domains.length > 0 && ((0, jsx_runtime_1.jsx)(AutoCompleteField_1.default, { name: "".concat(name, ".domain"), disableClearable: true, freeSolo: true, autoSelect: true, defaultValue: "".concat((email || defaultUserName || '').split('@')[1] || ''), label: t('ds.users.email domain'), options: domains.map(function (d) { return d.value; }), onChange: function (val) {
                    setTouched(true);
                    setValue(__assign(__assign({}, fieldProps.value), { value: "".concat((email || defaultUserName || '').replace(/@[^@]*$/, ''), "@").concat(val
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .replace(/\.+/g, '.')
                            .replace(/[^a-z0-9.-]/g, '')) }));
                } })), freeDomains && (domains === undefined || domains.length === 0) && ((0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(name, ".domain"), label: t('ds.users.email domain'), value: "".concat((email || defaultUserName || '').split('@')[1] || ''), disableFormik: true, required: required, forceError: (error || {}).value, onChange: function (e) {
                    setTouched(true);
                    setValue(__assign(__assign({}, fieldProps.value), { value: "".concat((email || defaultUserName || '').replace(/@[^@]*$/, ''), "@").concat(e.target.value
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .replace(/\.+/g, '.')
                            .replace(/[^a-z0-9.-]/g, '')) }));
                } })), !freeDomains && ((0, jsx_runtime_1.jsx)(SelectField_1.default, __assign({ name: "".concat(name, ".domain"), label: t('ds.users.email domain'), disableFormik: true, value: "".concat((email || defaultUserName || '').split('@')[1] || ''), onChange: function (e) {
                    setTouched(true);
                    setValue((0, exports.getValue)('domain', email, e.target.value));
                } }, { children: domains === null || domains === void 0 ? void 0 : domains.map(function (d) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: d.value }, { children: d.text }), d.text)); }) })))] }))) : ((0, jsx_runtime_1.jsx)(TextField_1.default, { readOnly: readOnly, name: "".concat(fieldProps.name, ".value"), label: label || t('ds.users.email'), error: !!error, required: required, helperText: (error || {}).value }));
}
exports.default = EmailField;
EmailField.defaultProps = {
    domains: undefined,
    label: undefined,
    readOnly: false,
    required: false,
    freeDomains: false,
    defaultUserName: '',
};
//# sourceMappingURL=EmailField.js.map